export enum RTImpactLinkTitleEnum {
  DOWNLOAD_PDF = "Download PDF",
  DOWNLOAD_EPUB = "Download EPUB",
  SUBMIT_MANUSCRIPT = "Submit",
  PARTICIPATE = "Participate in this",
  EMPTY = ""
}
